export default __webpack_public_path__ + "static/hiit_it_interval_timer_mac-move@3x-cd636b76b9d914b2a1685a8c571969f5.webp";